import { routes } from "../../Routes";

import homeIcon from "../../assets/home-icon.svg";
import selectedHomeIcon from "../../assets/home-icon-selected.svg";
import billsIcon from "../../assets/bills-icon.svg";
import selectedBillsIcon from "../../assets/bills-icon-selected.svg";
import documentsIcon from "../../assets/documents-icon.svg";
import selectedDocumentsIcon from "../../assets/documents-icon-selected.svg";
import eligibilityIcon from "../../assets/eligibility-icon.svg";
import selectedEligibilityIcon from "../../assets/eligibility-icon-selected.svg";
import { EligibilityStatus } from "../../services/authService/AuthService.type";
import { getEligibilityRoute } from "../../hooks/eligibility/useEligibilityRouting";

export interface NavigationItem {
  name: string;
  icon: string;
  selectedIcon: string;
  route: string;
  tooltip?: string;
}

export const generateHomepageLinksAndIcons = (
  status: EligibilityStatus | null
): NavigationItem[] => {
  const [eligibilityRoute] = getEligibilityRoute(status);

  return [
    {
      name: "HOME",
      icon: homeIcon,
      selectedIcon: selectedHomeIcon,
      route: routes.home.new
    },
    {
      name: "BILLS",
      icon: billsIcon,
      selectedIcon: selectedBillsIcon,
      route: routes.bills.upload,
      tooltip: "Bills is disabled till credit is approved"
    },
    {
      name: "ELIGIBILITY",
      icon: eligibilityIcon,
      selectedIcon: selectedEligibilityIcon,
      route: eligibilityRoute
    },
    {
      name: "DOCUMENTS",
      icon: documentsIcon,
      selectedIcon: selectedDocumentsIcon,
      route: routes.documents.new
    }
  ];
};

export const layoutConstants = {
  button: {
    logout: "LOG OUT"
  }
};

export enum GstinStatus {
  inactive = "INACTIVE",
  active = "ACTIVE"
}
